import axios from '@/lib/axios'
import { buildAdminRequestConfig, type OrganizationId } from '@/lib/organization-scoping'
import type { QueryFunctionContext } from '@tanstack/react-query'
import type {
  GoogleTagManagerIntegration,
  GoogleTagManagerIntegrationInput,
} from './google-tag-manager.types'

export interface GoogleTagManagerOrganizationScope {
  organizationId: OrganizationId
}

/** Query functions read only the key. */
type GoogleTagManagerQueryContext<TKey> = Pick<QueryFunctionContext<[TKey]>, 'queryKey'>

export function getGoogleTagManagerIntegration({
  queryKey: [{ organizationId }],
}: GoogleTagManagerQueryContext<GoogleTagManagerOrganizationScope>) {
  return axios.get<GoogleTagManagerIntegration>(
    '/google-tag-manager/integration',
    buildAdminRequestConfig({ organizationId })
  )
}

export function updateGoogleTagManagerIntegration({
  organizationId,
  container_id,
}: GoogleTagManagerIntegrationInput & GoogleTagManagerOrganizationScope) {
  return axios.put<GoogleTagManagerIntegration>(
    '/google-tag-manager/integration',
    { container_id },
    buildAdminRequestConfig({ organizationId })
  )
}

/** Disconnects the container and resolves to the disconnected integration. */
export function removeGoogleTagManagerIntegration({
  organizationId,
}: GoogleTagManagerOrganizationScope) {
  return axios.delete<GoogleTagManagerIntegration>(
    '/google-tag-manager/integration',
    buildAdminRequestConfig({ organizationId })
  )
}
